/**
 * CPV-AI-01 · the context the assistant opens with: read from the page the person is on (the "Ask CPV" button in the
 * top bar) and carried in the workspace's URL (/cpv/assistant?product=&plan=&parameter=&signal=&period_from=&period_to=).
 * The ids are the route's own; the server validates every one against the person's scope.
 */
export const WORKSPACE = '/cpv/assistant';
export const URL_KEYS = ['product', 'plan', 'parameter', 'signal', 'period_from', 'period_to'];

const ROUTES = [
  [/^\/cpv\/plans\/(\d+)\/charts\/(\d+)\/?$/, (m) => ({ plan: m[1], parameter: m[2] })],
  [/^\/cpv\/plans\/(\d+)(\/charts)?\/?$/, (m) => ({ plan: m[1] })],
  [/^\/cpv\/signals\/(\d+)\/?$/, (m) => ({ signal: m[1] })],
  [/^\/cpv\/master\/(\d+)(\/versions)?\/?$/, (m) => ({ product: m[1] })],
];

/** The context of the page at `pathname` + `search`: plan / parameter / signal from the route, a product filter from the query. */
export function contextOfPage(pathname, search = '') {
  const out = {};
  const q = new URLSearchParams(search);
  if (/^\d+$/.test(q.get('product') || '')) out.product = q.get('product');
  ROUTES.some(([re, pick]) => {
    const m = re.exec(pathname || '');
    if (m) Object.assign(out, pick(m));
    return Boolean(m);
  });
  return out;
}

/** The workspace's URL for a context (empty values dropped). */
export function workspacePath(context = {}) {
  const q = new URLSearchParams();
  URL_KEYS.forEach((k) => { const v = context[k]; if (v !== undefined && v !== null && v !== '') q.set(k, String(v)); });
  const s = q.toString();
  return s ? `${WORKSPACE}?${s}` : WORKSPACE;
}
